export default __webpack_public_path__ + "static/media/watch_later.8e33b901.svg";